import { useContext } from 'react';

// mui
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

// context
import { Context } from '../../../context/Context';

const Loading = ({ forceOpen = false }) => {
  const { state } = useContext(Context);
  const open = forceOpen || state.loading;

  return (
    <Backdrop sx={{ color: '#fff', zIndex: 9999999 }} open={open}>
      <CircularProgress color='inherit' />
    </Backdrop>
  );
};

export default Loading;
